import {
  FETCH_CATEGORY_PRODUCT,
  FETCH_CATEGORY_PRODUCT_SUCCESS,
  FETCH_CATEGORY_PRODUCT_FAILED
} from '../../types';

const initialState = {
  category_prod: [],
  isLoading: false,
  errors: {},
  error: false
}

const fetchCategoryProductReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_CATEGORY_PRODUCT:
      return {
        ...state,
        isLoading: true,
          category_prod: action.payload
      }
      case FETCH_CATEGORY_PRODUCT_SUCCESS:
        return {
          ...state,
          isLoading: false,
            category_prod: action.payload
        }
        case FETCH_CATEGORY_PRODUCT_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchCategoryProductReducer;
